var React = require('react');

function Cheveron02 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 30.791) rotate(-90)"},React.createElement("path",{"d":"M.348.348a1.184,1.184,0,0,1,1.677,0L15.4,13.721,28.767.347a1.186,1.186,0,0,1,1.677,1.677l-14.21,14.21a1.184,1.184,0,0,1-1.677,0L.348,2.024a1.184,1.184,0,0,1,0-1.677Z","fill":"currentColor"})));
}

Cheveron02.defaultProps = {"viewBox":"0 0 16.581 30.791"};

module.exports = Cheveron02;

Cheveron02.default = Cheveron02;
